import { createReducer, on } from '@ngrx/store';
import * as fromSchoolActions from '../actions/school.action';
export const featureKey = 'school';

export interface State {
    schoolContent: {
        data: Array<any>,
        isLoaded: Boolean
    };
    schoolSettings: {
        data: Array<any>,
        isLoaded: Boolean
    };
    schoolYear: {
        data: Array<any>,
        isLoaded: Boolean
    };
    schoolYearTerms: {
        data: Array<any>,
        isLoaded: Boolean
    };
    schoolYearPeriods: {
        data: Array<any>,
        isLoaded: Boolean
    };
    schoolYearEvents: {
        data: Array<any>,
        isLoaded: Boolean
    };
    formPrograms: {
        data: Array<any>,
        isLoaded: Boolean
    };
    professors: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    schoolContent: {
        data: [],
        isLoaded: false
    },
    schoolSettings: {
        data: [],
        isLoaded: false
    },
    schoolYear: {
        data: [],
        isLoaded: false
    },
    schoolYearTerms: {
        data: [],
        isLoaded: false
    },
    schoolYearPeriods: {
        data: [],
        isLoaded: false
    },
    schoolYearEvents: {
        data: [],
        isLoaded: false
    },
    formPrograms: {
        data: [],
        isLoaded: false
    },
    professors: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromSchoolActions.getSchoolContentSuccess, (state: State, props: any) => ({
        ...state,
        schoolContent: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getSchoolSettingsSuccess, (state: State, props: any) => ({
        ...state,
        schoolSettings: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getSchoolYearSuccess, (state: State, props: any) => ({
        ...state,
        schoolYear: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getSchoolYearTermsSuccess, (state: State, props: any) => ({
        ...state,
        schoolYearTerms: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getSchoolYearPeriodSuccess, (state: State, props: any) => ({
        ...state,
        schoolYearPeriods: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getSchoolYearEventsSuccess, (state: State, props: any) => ({
        ...state,
        schoolYearEvents: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getFormProgramsSuccess, (state: State, props: any) => ({
        ...state,
        formPrograms: { data: props.data, isLoaded: true },
    })),
    on(fromSchoolActions.getProfessorListSuccess, (state: State, props: any) => ({
        ...state,
        professors: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);